import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CheckoutActions } from "../actions";
import { ApiService } from "../../../../SGRE-shared/services/api.service";
import { switchMap, map, catchError, of, concatMap, takeUntil } from "rxjs";
import { pDropdown } from "../../../../SGRE-shared/models/primeng.model";
import { LoggerService, tryNormalizeHttpError } from "@spartacus/core";
import { CheckoutCartDetails } from "../../models/checkout.model";
import { CheckoutCartsState } from "../checkout.state";
import { CheckoutCartsEffectsService } from "./checkout-carts-effects.service";
import { GlobalService } from "../../../../SGRE-shared/services/global.service";

@Injectable()
export class CheckoutIncotermEffects {

    protected logger = inject(LoggerService);
    constructor(
        private actions$: Actions,
        private apiService: ApiService,
        private checkoutCartsEffectsService: CheckoutCartsEffectsService,
        private globalService: GlobalService
    ) { }

    loadIncoterm$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.loadIncoterm),
            switchMap(() => this.apiService.getIncoterms()
                .pipe(
                    takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                    map(data => {
                        const payload: pDropdown[] = data.incoterms.map((item: string) => ({ label: item, value: item }));
                        return CheckoutActions.loadIncotermSuccess({ payload });
                    }),
                    catchError(error => of(CheckoutActions.loadIncotermFail({
                        payload: tryNormalizeHttpError(error, this.logger)
                    })))
                )
            ),
        )
    );

    updateIncoterm$ = createEffect(() =>
    this.actions$.pipe(
        ofType(CheckoutActions.updateIncoterm),
        switchMap(({ updateCartId, getCartId, incotermVal, accordionType, orderType, legalEntityId }) =>
            this.apiService.putIncoterm(updateCartId, incotermVal, legalEntityId).pipe(
                takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                concatMap(() => {
                    const paramsObject = {
                        fields: 'FULL',
                        legalEntityId
                    };
                    return this.apiService.getCartsList(getCartId, paramsObject).pipe(
                        takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                        concatMap((checkoutCartsVal: CheckoutCartDetails) => {
                            let checkoutCartsData: CheckoutCartsState = this.checkoutCartsEffectsService.modifyCartData(checkoutCartsVal, orderType);
                            checkoutCartsData = {
                                ...checkoutCartsData,
                                warehouseCart: null
                            };
                            this.globalService.loadingSubject.next(false); 
                            // Emit each action individually
                            return [
                                CheckoutActions.updateIncotermSuccess(),
                                CheckoutActions.loadCheckoutCartsListSuccess({ payload: checkoutCartsData })
                            ];
                        })
                    );
                }),
                catchError(error => {
                    this.globalService.loadingSubject.next(false);
                    return of(CheckoutActions.updateIncotermFail({ payload: tryNormalizeHttpError(error, this.logger) }));
                })
            )
        )
    )
);
}